<template>
  <div
    class="alert alert-success text-left"
  >
    {{$t('stornierung.kostenfrei_vorverlegen')}}
  </div>
</template>

<script>
  export default {
    name: "VorverlegenInfo",
  };
</script>

<style>
</style>
